module.exports = __webpack_public_path__ + "img/pAppleW.59993192.svg";